<template>
  <div>

    <navbar :isAgent="true">
<!--      <template v-slot:actionButton>-->
<!--        <div class="buttons">-->
<!--          <b-button rounded outlined class="is-info" @click="$router.push({name:'agentSignup'})">Sign Up</b-button>-->
<!--        </div>-->
<!--      </template>-->
    </navbar>

    <!--sign in view-->
    <div v-if="authSuccess == false" class="container" style="margin-top: 5%">

      <div class="columns" style="height: 600px">

        <div class="column">
          <div class="box ml-5" style="width: 150%; height: 100%">
            <img  :src="require('@/assets/gifs/animation_640_l58gh1e8.gif')" alt="signup-gif" style="height: 550px;" align="left">
          </div>
        </div>

        <div class="column">
          <div class="box-1" style="height: 105%; margin-top: -2%">
            <p class="signIn is-size-1">Sign In</p>

            <div style="width: 90%; height: 500px; padding: 10px">
              <div class="mt-5">
                <b-field
                    :type="invalidUsername == '' ? 'is-info' : 'is-danger'"
                    :message="invalidUsername"
                    style="text-align: left"
                    label="Enter Your Username"
                    :label-position="labelPosition"
                >
                  <b-input
                      type="text"
                      v-model="formdata.username"
                      placeholder="Jasoncarter"
                      rounded
                      @input="resetInvalidStatus('invalidUsername')"
                  ></b-input>
                </b-field>
              </div>
              <div class="mt-5">
                <b-field
                    :type="invalidPassword == '' ? 'is-info' : 'is-danger'"
                    :message="invalidPassword"
                    style="text-align: left"
                    label="Enter Your Password"
                    :label-position="labelPosition"
                >
                  <b-input
                      type="password"
                      placeholder="*********"
                      v-model="formdata.password"
                      rounded
                      password-reveal
                      @input="resetInvalidStatus('invalidPassword')"
                  >
                  </b-input>
                </b-field>
              </div>

              <br />

              <div class="mt-3">
                <div class="buttons">
                  <b-button type="is-info" outlined rounded expanded  @click="validateAndSubmit" :loading="formIsSubmitting">Sign In</b-button>
                </div>
              </div>
              <p class="mt-5">
                Forgot Password? <router-link :to="{name:'agentForgetPwd'}" class="link">Click here</router-link>
              </p>
              <div style="margin-top: 30%">
                <p>
                  Don't Have an Account? <router-link :to="{name:'agentSignup'}">Sign Up</router-link>
                </p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div >

    <!--otpcode-->
    <otpcode-view v-if="showOtpComp" :otpcode="otpCode" :action="userAction"></otpcode-view>
    <update-password-modal v-if="showresetPsw" @close-resetpsw-modal="closeUpdatePasswordModal()" @update-psw-success="updatePasswordSuccess($event)"></update-password-modal>


  </div>



</template>

<script>
import Navbar from '@/components/common/Navbar'
import axios from "axios";
import OtpcodeView from "@/views/backend/OtpCode";
import UpdatePasswordModal from "@/components/backend/updatePasswordModal";

export default {
  name:"signIn-view",

  components:{
    UpdatePasswordModal,
    OtpcodeView,
    Navbar,

  },

  data(){
    return{
      labelPosition: "on-border",
      formdata:{
        username:'',
        password: '',
      },

      showOtpComp:false,
      showresetPsw:false,

      formIsInvalid: false,
      invalidUsername: '',
      invalidPassword: '',
      authSuccess:false,
      otpCode:'',
      userAction:'',


      regex:{
        password:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      },

      formIsSubmitting: false,

    }
  },

  methods:{

    closeUpdatePasswordModal:function (){
     this.showresetPsw = false
    },

    updatePasswordSuccess(e){
      console.log('otp code psw reset')
      console.log(e)
      this.authSuccess = true
      this.otpCode = e
      this.showOtpComp = true
      this.showresetPsw = false
    },

    validateForm: function(){
      var formIsValid = true

      // username
      if(this.formdata.username =='' ){
        this.invalidUsername = 'This field cannot left blank'
        formIsValid = false
      }
      // else if(!this.regex.email.test(this.formdata.username)){
      //   this.invalidUsername = 'Please enter valid email address'
      //   formIsValid = false
      // }

      // password
      if(this.formdata.password =='' || this.formdata.password.indexOf(' ') >= 0) {
        this.invalidPassword = 'Password cannot be empty'
        formIsValid = false
      }
      // }else if(this.formdata.password.length < 8){
      //   this.invalidPassword = 'Password must be at least 8 characters'
      //   formIsValid = false
      // }else if(this.formdata.password.length > 20){
      //   this.invalidPassword = 'Password must be 8 - 20 characters'
      //   formIsValid = false
      // }else if(!this.regex.password.test(this.formdata.password)){
      //   this.invalidPassword = 'Password must be contain at least one letter, one number and one special character'
      //   formIsValid = false
      // }



      if(formIsValid){
        return true
      }
      else{
        return false
      }

    },

    submitForm:function (){
      var component = this
      component.formIsSubmitting = true

      axios.post(component.$base_url+'/agent/login', {
        username:component.formdata.username,
        password:component.formdata.password,

      })
          .then(function (data) {
            var array =[]
            array = data.data
            component.formIsSubmitting = false
            console.log(array.data)
            if(array.success == true){

              if(array.data.otpCode == ''){
                component.authSuccess =false
                component.otpCode=null
                component.showOtpComp = false //show otp modal
                component.showresetPsw = true // show reset psw modal
                component.$root.user_id   = array.data.user_id
                component.$root.agentAuthToken = array.data.authToken
                component.$root.agentEmail = array.data.email
                component.userAction = array.data.action
                component.$root.user_id   = array.data.user_id
                component.$root.user_role = array.data.userRole
                component.$root.agentName = array.data.agentName
                component.$root.agentContactNumber = array.data.contactNumber
                component.formIsSubmitting = false
              }else{
                component.showOtpComp = true //show otp modal
                component.showresetPsw = false // show reset psw modal
                component.authSuccess =true
                component.otpCode=array.data.otpCode
                component.userAction = array.data.action
                component.formIsSubmitting = false
                component.$root.agentAuthToken = array.data.authToken
                component.$root.agentContactNumber = array.data.contactNumber
                component.$root.agentEmail = array.data.email
                component.$root.agentName = array.data.agentName
                component.$root.user_role = array.data.userRole
                component.$root.user_id   = array.data.user_id
              }


            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.formIsSubmitting = false
            }

          })
          .catch(function (error) {
            console.log(error)
          });
    },

    resetInvalidStatus: function(key){

      this[key] = ''
      this.formIsInvalid = false


    },

    validateAndSubmit: function(){
      if(this.validateForm()){
        this.submitForm()
      }
      else{
        this.formIsInvalid = true
      }
    },

  }
}
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .box{
    display: none;
  }

}

.signIn {
  padding-top: 30px;
  font-weight: bold;
  background: -webkit-linear-gradient(#3a8fff 0 30%, #0837ae 55% 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

p {
  color: gray;
  font-weight: 500;
}
.link {
  color: #0d5da3;
  text-decoration: underline;
  cursor: pointer;
}
.link:hover {
  color: #092bc2;
  text-shadow: 1px;
}

.box-1 {
  position: relative;
  z-index: 1;
  background-color: white;
  border-radius: 0 15px 15px 0;
  box-shadow: 0 -5px 5px -5px #333, 5px 0 5px -5px #333, 0 5px 5px -5px #333;
}
.box-1::before {
  position: absolute;
  left: -5%;
  content: "";
  width: 70px;
  z-index: -1;
  height: 100%;
  background-color: inherit;
  border-radius: 15px 0 0 15px;
  box-shadow: 0 -1px 5px -5px #333, -5px 0 5px -5px #333, 1px 5px 0px -5px #333;
  /* box-shadow: 0px 10px 0px 0 rgb(41, 33, 33); */
  transform: skew(-5deg);
}

</style>
